export class CreatureOrderStorage {

    private static readonly MINI_PANEL_KEY = 'creature_order_mini';
    private static readonly UNLIMITED_PANEL_KEY = 'creature_order_unlimited';

    /**
     * Сохраняет порядок существ для мини-панели
     * @param creatureIds массив ID существ в порядке их расположения (слева направо)
     */
    public static saveMiniPanelOrder(creatureIds: number[]): void {
        try {
            if (localStorage) {
                localStorage.setItem(this.MINI_PANEL_KEY, JSON.stringify(creatureIds));
            }
        } catch (ignore) {}
    }

    /**
     * Сохраняет порядок существ для неограниченной панели
     * @param creatureIds массив ID существ в порядке их расположения (слева направо)
     */
    public static saveUnlimitedPanelOrder(creatureIds: number[]): void {
        try {
            if (localStorage) {
                localStorage.setItem(this.UNLIMITED_PANEL_KEY, JSON.stringify(creatureIds));
            }
        } catch (ignore) {}
    }

    /**
     * Получает сохраненный порядок существ для мини-панели
     * @returns массив ID существ в сохраненном порядке или null если порядок не сохранен
     */
    public static getMiniPanelOrder(): number[] | null {
        try {
            if (localStorage) {
                const orderStr = localStorage.getItem(this.MINI_PANEL_KEY);
                if (orderStr) {
                    return JSON.parse(orderStr);
                }
            }
        } catch (ignore) {}
        return null;
    }

    /**
     * Получает сохраненный порядок существ для неограниченной панели
     * @returns массив ID существ в сохраненном порядке или null если порядок не сохранен
     */
    public static getUnlimitedPanelOrder(): number[] | null {
        try {
            if (localStorage) {
                const orderStr = localStorage.getItem(this.UNLIMITED_PANEL_KEY);
                if (orderStr) {
                    return JSON.parse(orderStr);
                }
            }
        } catch (ignore) {}
        return null;
    }

    /**
     * Очищает сохраненный порядок для мини-панели
     */
    public static clearMiniPanelOrder(): void {
        try {
            if (localStorage) {
                localStorage.removeItem(this.MINI_PANEL_KEY);
            }
        } catch (ignore) {}
    }

    /**
     * Очищает сохраненный порядок для неограниченной панели
     */
    public static clearUnlimitedPanelOrder(): void {
        try {
            if (localStorage) {
                localStorage.removeItem(this.UNLIMITED_PANEL_KEY);
            }
        } catch (ignore) {}
    }

    /**
     * Сортирует массив существ по сохраненному порядку
     * @param creatures массив существ для сортировки
     * @param isMiniPanel true для мини-панели, false для неограниченной панели
     * @returns отсортированный массив существ
     */
    public static sortCreaturesByOrder(creatures: any[], isMiniPanel: boolean): any[] {
        const savedOrder = isMiniPanel ? this.getMiniPanelOrder() : this.getUnlimitedPanelOrder();
        
        if (!savedOrder || savedOrder.length === 0) {
            return creatures;
        }

        // Создаем карту для быстрого поиска позиции существа
        const orderMap = new Map<number, number>();
        savedOrder.forEach((id, index) => {
            orderMap.set(id, index);
        });

        // Сортируем существ по сохраненному порядку
        return creatures.sort((a, b) => {
            const aOrder = orderMap.get(a.id);
            const bOrder = orderMap.get(b.id);
            
            // Если оба существа есть в сохраненном порядке
            if (aOrder !== undefined && bOrder !== undefined) {
                return aOrder - bOrder;
            }
            
            // Если только одно существо есть в сохраненном порядке
            if (aOrder !== undefined) {
                return -1; // a идет первым
            }
            if (bOrder !== undefined) {
                return 1; // b идет первым
            }
            
            // Если ни одно существо не найдено в сохраненном порядке, сортируем по весу
            const aWeight = a.weight || 0;
            const bWeight = b.weight || 0;
            return aWeight - bWeight;
        });
    }
    
    /**
     * Проверяет, есть ли сохраненный порядок для панели
     * @param isMiniPanel true для мини-панели, false для неограниченной панели
     * @returns true если есть сохраненный порядок
     */
    public static hasSavedOrder(isMiniPanel: boolean): boolean {
        const savedOrder = isMiniPanel ? this.getMiniPanelOrder() : this.getUnlimitedPanelOrder();
        return savedOrder !== null && savedOrder.length > 0;
    }
} 